// libs
import { styled } from '@nykaa/ui-components';

// styles
import { BASE_GUTTER_SPACE, BREAKPOINTS, MEDIA_BREAKPOINTS } from 'shared/styles/base';

// components
import BasePromotionText from 'shared/components/PromotionText';
import ModelWidget from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/components/ModelWidget';

export const aspectRatio = 0.75;
export const FALLBACK_ASPECT_RATIO_CLASS = 'aspect-ratio';

export const Container = styled.div`
  width: 100%;
  padding-top: ${({ theme }) => theme.spacing.spacing50};

  @media (min-width: ${BREAKPOINTS.MOBILE}px) and (max-width: ${BREAKPOINTS.TABLET}px) {
    padding: ${({ theme }) => `0 ${theme.spacing.spacing80}`};
  }

  ${MEDIA_BREAKPOINTS.MOBILE} {
    width: 100%;
    padding: ${({ theme }) => `0 ${theme.spacing.spacing80}`};
  }
`;

export const SecondaryContent = styled.section`
  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-top: ${({ theme }) => theme.spacing.spacing100};
    padding-top: ${({ theme }) => theme.spacing.spacing40};
  }
`;

export const Separator = styled.div`
  margin: ${({ theme }) => `0 0 ${theme.spacing.spacing80} 0`};
  border-top: solid 1px ${({ theme }) => theme.colors.textOutline};
`;

export const BlockSeparator = styled.div`
  width: calc(100% + ${BASE_GUTTER_SPACE * 4}px);
  height: 1px;
  background: ${({ theme }) => theme.colors.textOutline};
  ${({ theme }) =>
    `margin: ${theme.spacing.spacing80} 0 ${theme.spacing.spacing80} -${theme.spacing.spacing80}`};
`;

export const SizeSelectorBlockSeparator = styled(BlockSeparator)`
  ${({ theme }) => `
  margin: ${theme.spacing.spacing120} 0 ${theme.spacing.spacing80} -${theme.spacing.spacing80}`};
`;

export const Header = styled.h3`
  ${({ theme }) => theme.typography.subTitleLarge};
  margin: 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  padding-bottom: ${({ theme }) => theme.spacing.spacing40};
`;

export const CustomModelWidget = styled(ModelWidget)`
  margin: ${({ theme }) => `${theme.spacing.spacing80} 0 ${theme.spacing.spacing120}`};

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-bottom: ${({ theme }) => theme.spacing.spacing80};
  }
`;

export const SelectDeliveryLocation = styled.div`
  margin-top: ${({ theme }) => `${theme.spacing.spacing80}`};
`;

export const PromotionText = styled(BasePromotionText)`
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  ${({ theme }) => theme.typography.bodySmall};
`;

export const SizeGuideNudgeContainer = styled.div`
  margin: ${({ theme }) => `${theme.spacing.spacing80} 0 ${theme.spacing.spacing100} 0`};

`;
export const aspectRatioFallbackCSS = `
@supports not (aspect-ratio: 0) {
  padding-top: ${100 / aspectRatio}%;
  height: 0;
  position: relative;

  .${FALLBACK_ASPECT_RATIO_CLASS} {
    position: absolute;
    transform: translate(-50%, 0);
    left: 50%;
    top: 0;
    max-width: 100%;
    height: auto;
  }
}
`;
